var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content has-text-grey has-text-centered"},[_c('p',[_c('b-icon',{attrs:{"icon":"emoticon-sad","size":"is-large"}})],1),_c('p',[_vm._v("Nenhum registro encontrado")])])
}
var staticRenderFns = []

export { render, staticRenderFns }